<template>
    <form-row title="Have you arranged for transfer stamps?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="has_arranged_transfer_stamps"
                v-model="has_arranged_transfer_stamps"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <input-date
                v-if="has_arranged_transfer_stamps"
                class="mt-4 sm:ml-12 sm:-mt-2 sm:-mb-2 flex flex-1 items-center sm:justify-end"
                label="Date Arranged:"
                :value="attorney.arranged_transfer_stamps_at"
                name="arranged_transfer_stamps_at"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        attorney: {},
        read_only: { default: false },
    },

    data() {
        return {
            has_arranged_transfer_stamps: this.attorney.has_arranged_transfer_stamps,
        }
    },
}
</script>
